import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import { API_URL } from "@/common/utils/env";

export default function useGithubConnectionUrl(): string {
  const { org, app } = useEnvironment();

  if (!org || !app) {
    return "";
  }

  const redirectUri = window.location.href.replace(window.location.origin, "");

  const searchParams = {
    redirectUri,
  };

  return `${API_URL}/orgs/${org.id}/github/connect?${new URLSearchParams(
    searchParams,
  ).toString()}`;
}
